import { catchError, map, switchMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { getSelectedBusinessLine, OrderBuilderState } from '../../../../reducers';
import { IEffect } from '../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  POD_LOAD,
  PODLoadAction,
  PODLoadCompleteAction,
  PODLoadFailAction,
  PODRemoveSelectedAction,
  PODLoadInitialStateAction,
} from '../../actions/point-of-delivery-actions/point-of-delivery.actions';
import { IShipmentLocationResponse } from '@cemex-core/cmx-api/models/shipment-location/shipment-location-response';
import { ShipmentLocationsService } from '@cemex-core/cmx-api';
import { IShipmentLocationRequest } from '@cemex-core/cmx-api/models/shipment-location/shipment-location-request';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { ProductType } from '@cemex-core/cmx-api/models/business-lines/product-type';
import { SHIPMENT_LOCATION_TYPE_ID } from '@ordersnproducts/modules/shared/constants/shipment-location-type-id';
import { LS_JOBSITE_SET, JobsiteSetAction } from '../../actions/jobsite-actions/jobsite.actions';
import { Jobsite } from '../../models/order-management/jobsite.model';

@Injectable()
export class PODLoadEffects implements IEffect {
  pointOfDeliveryRemoveSelected$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_JOBSITE_SET),
      map((payload: JobsiteSetAction) => {
        return new PODRemoveSelectedAction(null);
      }),
    ),
  );

  PODjobsiteSetLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LS_JOBSITE_SET),
      map((action: JobsiteSetAction) => {
        if (action.payload) {
          return new PODLoadAction(action.payload);
        } else {
          return new PODLoadInitialStateAction();
        }
      }),
    ),
  );

  pointOfDeliveryLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(POD_LOAD),
      switchMap((payload: PODLoadAction) => {
        return this.store
          .select(getSelectedBusinessLine)
          .pipe(take(1))
          .pipe(
            map((selectedBusinessLine: ProductType) => _safe(() => selectedBusinessLine.productTypeId)),
            switchMap((businessLineId: number) => {
              return this.shipmentLocationService
                .getShipmentLocations(this.preparePointOfDeliveryLoadRequest(payload.payload, businessLineId))
                .pipe(
                  map((shipmentLocationResponse: IShipmentLocationResponse) => {
                    return new PODLoadCompleteAction(shipmentLocationResponse);
                  }),
                  catchError((error) => of(new PODLoadFailAction(error))),
                );
            }),
          );
      }),
    ),
  );

  constructor(
    private store: Store<OrderBuilderState>,
    private actions$: Actions,
    private shipmentLocationService: ShipmentLocationsService,
  ) {}

  private preparePointOfDeliveryLoadRequest(selectedJobsite: Jobsite, businessLine: number): IShipmentLocationRequest {
    return {
      shipmentLocationId: {
        entityId: selectedJobsite.jobsiteId,
        entityTypeId: SHIPMENT_LOCATION_TYPE_ID.JOBSITE,
      },
      shipmentLocationTypeId: [
        SHIPMENT_LOCATION_TYPE_ID.POINT_OF_DELIVERY,
        SHIPMENT_LOCATION_TYPE_ID.POINT_OF_DELIVERY_REQUEST,
      ].join(','),
      productLineId: businessLine,
    };
  }
}
